import "./App.css";
import { createBrowserRouter, Outlet } from "react-router-dom";
import { Body } from "./Body";

import ContactUs from "./ContactUs";
import { Header } from "./common/Header";
import DirectorMessage from "./Leadership/DirectorMessge";
import EducatorMessage from "./Leadership/EducatorMessage";
import ScrollToTop from "./ScrollToTop";
import Footer from "./common/Footer";
import AdmissionEnquiry from "./AdmissionEnquiry";
import MonthEnd from "./MonthEnd";
function App() {
  return (
    <div>
      <Header />

      <Outlet />

      <Footer />

      <ScrollToTop />
      <AdmissionEnquiry />
    </div>
  );
}

export const appRouter = createBrowserRouter([
  {
    path: "/",
    element: <App />,
    children: [
      {
        path: "/",
        element: <Body />,
      },
      {
        path: "/about/history",
        element: <DirectorMessage />,
      },
      {
        path: "/about/leadership",
        element: <EducatorMessage />,
      },
      {
        path: "/about/mission",
        element: <DirectorMessage />,
      },
      {
        path: "/contact",
        element: <ContactUs />,
      },
      {
        path: "/monthendprocess",
        element: <MonthEnd />,
      }
    ],
  },
]);

export default App;
